// components are restricted to elements only
// scope is always isolated
// the bindings property binds to controller
// controllerAs value is $ctrl by default

// tslint:disable:max-line-length
angular.module('nv.components.autocomplete-floating-label').component('nvAutocompleteFloatingLabel', {
  template: require('./nv-autocomplete-floating-label.html'),
  bindings: {
    // isolates scope
    floatingLabel: '@',
    items: '<',
    selectedItem: '=',
    field: '@',
    onChange: '&',
  },
  controller: 'nvAutocompleteFloatingLabelCtrl',
});
